import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '@hs/ui-core-presentation';

import { ButtonLabel } from '../../../models/dashboard-note';

@Component({
    selector: 'ddv-view-dashboard-note-button',
    templateUrl: './view-note-button.component.html',
    styleUrls: ['./view-note-button.component.scss'],
    imports: [
        IconComponent,
    ],
    host: {
        '(mouseenter)': 'hovered = true',
        '(mouseleave)': 'hovered = false',
        '[class.hovered]': 'hovered',
        '(click)': 'onClick($event)',
    },
})
export class ViewNoteButtonComponent {
    @Input() label: ButtonLabel = 'View Notes';
    @Output() pressed = new EventEmitter<void>();

    protected hovered = false;

    protected onClick(event: MouseEvent): void {
        event.stopPropagation();
        this.pressed.emit();
    }
}
